import { useEffect } from 'react';

const BASE_URL = 'https://lodiss.creativecomet.tn';

export function usePageTitle(title: string, description?: string, canonicalPath?: string) {
  useEffect(() => {
    document.title = title;
    
    // Update canonical URL
    const canonicalLink = document.getElementById('canonical-link') as HTMLLinkElement | null;
    if (canonicalLink) {
      const path = canonicalPath || '';
      canonicalLink.href = `${BASE_URL}${path}`;
    } else {
      const newCanonical = document.createElement('link');
      newCanonical.rel = 'canonical';
      newCanonical.id = 'canonical-link';
      newCanonical.href = `${BASE_URL}${canonicalPath || ''}`;
      document.head.appendChild(newCanonical);
    }
    
    if (description) {
      let metaDesc = document.querySelector('meta[name="description"]');
      if (!metaDesc) {
        metaDesc = document.createElement('meta');
        metaDesc.setAttribute('name', 'description');
        document.head.appendChild(metaDesc);
      }
      metaDesc.setAttribute('content', description);
      
      let ogDesc = document.querySelector('meta[property="og:description"]');
      if (ogDesc) {
        ogDesc.setAttribute('content', description);
      }
      
      let twitterDesc = document.querySelector('meta[name="twitter:description"]');
      if (twitterDesc) {
        twitterDesc.setAttribute('content', description);
      }
    }
  }, [title, description, canonicalPath]);
}
